"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerRenderedHtmlParserWidget = void 0;
const react_1 = __importDefault(require("react"));
const html_react_parser_1 = __importStar(require("html-react-parser"));
const script_1 = __importDefault(require("next/script"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const styles_1 = require("./styles");
const ServerRenderedHtmlParserWidget = (props) => {
    const { html = '', isDangerousHtml = false } = props, rest = __rest(props, ["html", "isDangerousHtml"]);
    if (!html) {
        return null;
    }
    const options = {
        replace(domNode) {
            if (domNode instanceof html_react_parser_1.Element && domNode.attribs && domNode.type === 'script') {
                return react_1.default.createElement(script_1.default, { src: domNode.attribs.src }, (0, html_react_parser_1.domToReact)(domNode.childNodes));
            }
        }
    };
    const content = (0, html_react_parser_1.default)(html, options);
    if (!isDangerousHtml) {
        monera_app_core_1.LOGGER.info('If you do not see HTML content rendered, please set the isDangerousHTML prop to true such that you acknowledge the risk of rendering non-sanitised HTMl content');
    }
    return isDangerousHtml ? (react_1.default.createElement(styles_1.StyledHtmlWidgetContainer, Object.assign({ "data-cy": 'html-widget-container' }, rest),
        react_1.default.createElement(react_1.default.Fragment, null, content))) : null;
};
exports.ServerRenderedHtmlParserWidget = ServerRenderedHtmlParserWidget;
